module.exports = __webpack_public_path__ + "img/0.f64d647f.png";